import { m } from '~/paraglide/messages'
import type { ChallengeProgress } from '~/resources/focus-challenges'

export function challengeTitle(
  progress: ChallengeProgress,
  treeName: string | null,
): string {
  const { type, tree_type } = progress.challenge_difficulty
  const number = progress.target
  const useTree = tree_type != null && treeName != null && treeName !== ''

  if (type === 'focus_time') {
    return useTree
      ? m.daily_task_tree_type_duration({ number, tree: treeName! })
      : m.daily_task_duration({ number })
  }
  if (type === 'plant_count') {
    return useTree
      ? m.daily_task_tree_type_focus_times({ number, tree: treeName! })
      : m.daily_task_focus_times({ number })
  }
  return ''
}
